export default __webpack_public_path__ + "static/media/check-view.5e9bf4d7.svg";